export default {
  allowLassoOnContainer(editorAPI: AnyFixMe, compRef: AnyFixMe) {
    const pageRef = editorAPI.components.getPage(compRef);
    return editorAPI.dsRead.pages.isWidgetPage(pageRef.id);
  },
};
